import { DocsTocGroup } from '../types';
import { HELP_TABLE_OF_CONTENTS } from './help';
import { RELEASE_NOTES_TABLE_OF_CONTENTS } from './releaseNotes';
import { ROUTES } from './routes';

export const GETTING_STARTED_TABLE_OF_CONTENTS: DocsTocGroup[] = [
  {
    heading: 'Getting Started',
    items: [
      {
        label: 'Overview',
        route: `${ROUTES.gettingStarted}#getting-started-with-dx-portal-and-apis`,
      },
      {
        label: 'Step 1: Explore APIs in DX Portal',
        route: `${ROUTES.gettingStarted}#step-1-explore-apis-in-dx-portal`,
      },
      {
        label: 'Step 2: Retrieve Client Credentials',
        route: `${ROUTES.gettingStarted}#step-2-retrieve-client-credentials`,
      },
      {
        label: 'Step 3: Obtain an Access Token',
        route: `${ROUTES.gettingStarted}#step-3-obtain-an-access-token`,
      },
      {
        label: 'Step 4: Execute API Requests',
        route: `${ROUTES.gettingStarted}#step-4-execute-api-requests`,
      }
    ],
  },
];

export const LANDING_PAGE_GUIDE_TABLE_OF_CONTENTS: DocsTocGroup[] = [
  {
    heading: 'Landing Page Guide',
    items: [
      {
        label: 'Overview',
        route: ROUTES.landingPageGuide,
      },
      {
        label: 'Environments',
        route: ROUTES.environments,
      },
      {
        label: 'Registration',
        route: ROUTES.registration,
      },
      {
        label: 'Troubleshooting',
        route: ROUTES.troubleshooting,
      },
      {
        label: 'Support',
        route: ROUTES.support,
      },
    ],
  },
];

export const SERVICE_MANAGEMENT_API_TABLE_OF_CONTENTS: DocsTocGroup[] = [
  {
    heading: 'Service Management API',
    items: [
      {
        label: 'Overview',
        route: ROUTES.serviceManagement,
      },
    ],
  },
];

export const TABLE_OF_CONTENTS_BY_TAB_ID: Record<string, DocsTocGroup[]> = {
  home: [],
  'getting-started': GETTING_STARTED_TABLE_OF_CONTENTS,
  'landing-page-guide': LANDING_PAGE_GUIDE_TABLE_OF_CONTENTS,
  'service-management-api': SERVICE_MANAGEMENT_API_TABLE_OF_CONTENTS,
  help: HELP_TABLE_OF_CONTENTS,
  'release-notes': RELEASE_NOTES_TABLE_OF_CONTENTS,
};
